import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Checkbox, CircularProgress, IconButton, Radio } from '@mui/material';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarRateIcon from '@mui/icons-material/StarRate';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Row } from '@tanstack/react-table';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { getFavoritePayload } from 'src/components/layout/appDrawer/utils';
import { toggleFavorite } from 'src/pages/analytics/landing/store/landing-slice';
import Storage from 'src/utils/storage/storage';
import { Header, TableComponent } from '../../types/generic-table.model';
import {
  addSelectedScenario,
  removeUnselectedScenario
} from '../../store/pricing-simulator-slice';

import './table-columns.scss';

export default function CheckboxWithLabel({
  row,
  columnMetadata,
  componentType = {}
}: {
  row: Row<{ [key: string]: any }>;
  columnMetadata: Header;
  componentType?: any;
}) {
  const [isSelectedBadgeVisible, setSelectedBadgeVisible] = useState(false);
  const appDispatch = useAppDispatch();

  const location = useLocation(); // React Router's location hook

  const currUrl = location.pathname.split('/').pop();

  // local state for toggling favorite icon
  const [isFavorite, setIsFavorite] = useState(row.original.is_favourite);

  //   local state for loader while calling favorite api
  const [isFavoriteLoading, setIsFavoriteLoading] = useState(false);

  const { source: sourceId } = Storage.getSourceId();

  const handleValueChange = (
    _e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    row.toggleSelected(checked);
  };

  useEffect(() => {
    if (row.getIsSelected()) {
      setSelectedBadgeVisible(row.getIsSelected());
      appDispatch(
        addSelectedScenario({ selectedItemID: row.original.scenario_id })
      );
    } else {
      setSelectedBadgeVisible(row.getIsSelected());
      appDispatch(
        removeUnselectedScenario({ unSelectedItemID: row.original.scenario_id })
      );
    }
  }, [row.getIsSelected()]);

  // handler for toggling favorite
  const handleToggleFavorite = () => {
    console.log('row:', row);
    // setting loader true while calling the api
    setIsFavoriteLoading(true);

    // getting the formatted payload
    const favPayload = getFavoritePayload(row.original, !isFavorite);
    // calling the favorite api for toggling the item as favorite
    appDispatch(toggleFavorite({ ...favPayload, sourceID: sourceId }))
      .then(() => {
        setIsFavorite(!isFavorite);
        setIsFavoriteLoading(false);
      })
      .catch((error) => {
        setIsFavoriteLoading(false);
      });
  };

  return (
    <div className='checkbox-label-cell '>
       {/* OPTION1: BELOW CODE (Line: 56 - 76)HAS LOGIC FOR SHOWING ORDER OF SELECTION on UI ,If opting OPTION 1, then Comment OPTION 2 */}
      {/* {componentType === 'SCENARIOMANAGER' 
      ? ( <FormControlLabel
          key={row.original[columnMetadata.parent.parent_field]}
          control={
            <Checkbox
              onChange={handleValueChange}
              checked={isSelectedBadgeVisible && selectedScenarioIDarray.includes(row.original[columnMetadata.parent.parent_field])}
              icon={<div style={{ width: '1em', height: '1em', border: '2px solid rgba(0,0,0,0.6)',borderRadius: '8%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{row.getIsSelected() ? selectedScenarioIDarray.findIndex(el => el == row.original[columnMetadata.parent.parent_field]) + 1 : ''}</div>}
              checkedIcon={<div style={{ width: 20, height: 20, border: '1px solid rgba(0,0,0,0.6) ',borderRadius: '8%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#0000A0', color: 'white' }}>{row.getIsSelected() ? selectedScenarioIDarray.findIndex(el => el == row.original[columnMetadata.parent.parent_field]) + 1 : ''}</div>}
            />
          }
          label={<span style={{ fontSize: '12px',fontWeight: '400'}}>{row.original[columnMetadata.parent.parent_field]}</span>}
        />) 
        : (<Checkbox
        checked={isSelectedBadgeVisible}
        onChange={handleValueChange}
        size='small'
        // placeholder='-'
      />) 
      }
      {componentType !== 'SCENARIOMANAGER' && row.original[columnMetadata.parent.parent_field]} */}

      {/* displaying fav icon for marking scenarios as favorite */}

      {componentType === 'SCENARIOMANAGER' ? (
        <div className='fav-icon-div'>
          {currUrl.toLowerCase() === 'scenario-manager' ? (
            <IconButton
              aria-label='add to favorites'
              onClick={handleToggleFavorite}
            >
              {isFavoriteLoading ? (
                <CircularProgress size={16} />
              ) : isFavorite ? (
                <StarRateIcon sx={{ fontSize: '20px', color: '#0000a0' }} />
              ) : (
                <StarOutlineIcon sx={{ fontSize: '20px' }} />
              )}
            </IconButton>
          ) : (
            <div
              className='fav-icon-div'
              style={{ position: 'relative', top: '1px', padding: '8px' }}
            >
              {row.original.is_favourite && (
                <StarRateIcon sx={{ fontSize: '18px', color: '#0000a0' }} />
              )}
            </div>
          )}
        </div>
      ) : (
        ''
      )}

      {/* OPTION 2:  BELOW code (LINE 79 -85) has logic to store the order of selection, but order doesn't reflect in UI */}
      {componentType === 'SCENARIOMANAGER' && window.location.pathname.includes('cluster-summary') ? (
        <Radio
          checked={isSelectedBadgeVisible}
          onChange={handleValueChange}
          size='small'
          // placeholder='-'
          />
      ) : (
         <Checkbox
        checked={isSelectedBadgeVisible}
        onChange={handleValueChange}
        size='small'
        // placeholder='-'
      />
      )}
      {/* <Checkbox
        checked={isSelectedBadgeVisible}
        onChange={handleValueChange}
        size='small'
        // placeholder='-'
      /> */}
      {row.original[columnMetadata.parent.parent_field]}

      {row.original.is_finalized && (
        <div className='finalized-table-flag'>
          <img src='/static/icons/finalized-scenario.svg' alt='finalized' />
        </div>
      )}
    </div>
  );
}
